import React from 'react';
import { BallTriangle } from 'react-loader-spinner';

const SpenerLoding = () => {
    return (
        <div className='w-full flex justify-center py-10'>
            <div>
                <BallTriangle
                height={100}
                width={100}
                radius={5}
                color="#4fa94d"
                ariaLabel="ball-triangle-loading"
                wrapperClass={{}}
                wrapperStyle=""
                visible={true}
                />
            </div>
        </div>
    );
};

export default SpenerLoding;